export default {
  methods: {
    openPlaceSelectionModal(options = {}) {
      return new Promise((resolve, reject) => {
        this.$sessionStore.commit("openPlaceSelectionModal", {
          resolve,
          reject,
          activeTab: options.activeTab || "select",
          selectedPlaces: options.selected_places || [],
          initialShowReview: options.startOnReview || false,
          // Per-flow cap on how many places may be selected in the modal.
          // Omitted/invalid -> 0, which the store/modal treat as "no limit".
          maxPlaces: options.maxPlaces,
        });
      });
    },
  },
};
